import SnwButtonContainer from "@@/components/Button/SnwButtonContainer";
import { SnwButtonType } from "@@/components/Button/buttonProps";
import DescriptionCard, {
 DescriptionCardProps,
} from "@@/components/Card/Description";
import Box from "@@/elements/Box";
import Container from "@@/elements/Container";
import Typography from "@@/elements/Typography";
import {
  ScreenSize,
  useIsBreakpointAndAbove,
} from "@@/hooks/device/use-breakpoint";
import EpiContent from "@@/integrations/optimizly/Content";
import EpiProperty from "@@/integrations/optimizly/Property";
import cn from "classnames";

import styles from "../cardContainer.module.scss";

export type DescriptionContainerProperties = {
  header?: string;
  intro?: string;
};

export type DescriptionContainerOwnProps = {
  backgroundColor: BackgroundColor;
  buttons?: SnwButtonType[];
  size: "small" | "large";
  cards: DescriptionCardProps[];
};

export type BackgroundColor = "beige" | "white";

export type DescriptionContainerProps =
  DescriptionContainerProperties & DescriptionContainerOwnProps;

export const colorMapper = (color) => {
  switch (color) {
  case "beige":
    return "ComplementaryBeigeTint03";
  case "white":
    return "White";
  default:
    return "ComplementaryBeigeTint03";
  }
};

const DescriptionContainer = ({
  backgroundColor,
  header,
  intro,
  buttons,
  size,
  cards,
}: DescriptionContainerProps) => {
  const containerClassNames = cn({
    [styles.container_service]: size === "large",
    [styles.container_service_small]: size === "small",
    [styles.container_service__flex]: cards.length < 3,
  });

  return (
    <Box
      component="section"
      backgroundColor={colorMapper(backgroundColor)}
      className={styles.block}
    >
      <Container component="div">
        <Box
          mb={[10, 12, 14]}
          width="full"
          flexDirection="column"
          alignItems="center"
        >
          {header && (
            <EpiProperty<DescriptionContainerProperties> name="header">
              <Typography
                asElement="h2"
                variant="heading1"
                textAlign="center">
                {header}
              </Typography>
            </EpiProperty>
          )}
          {intro && (
            <EpiProperty<DescriptionContainerProperties> name="intro">
              <Typography
                variant="intro"
                textAlign="center"
                mt={8}>
                {intro}
              </Typography>
            </EpiProperty>
          )}
          {buttons && buttons.length > 0 && (
            <Box
              mt={8}
              width={"full"}
              justifyContent={"center"}
              flexDirection={["column", "row", "row"]}
              gap={6}>
              <SnwButtonContainer buttons={buttons} />
            </Box>
          )}
        </Box>
          <EpiContent>
            <Box className={containerClassNames}>
              {cards?.map((card, i) => (
                <DescriptionCard
                  key={i}
                  header={card.header}
                  body={card.body}
                  image={card.image}
                  size={size}
                  buttons={card.buttons}
                  backgroundColor={backgroundColor}
                  slider={false}
                />
              ))}
            </Box>
          </EpiContent>
      </Container>
    </Box>
  );
};
export default DescriptionContainer;
